import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// English
import enCommon from './en/common.json';
import enAuth from './en/auth.json';
import enChat from './en/chat.json';
import enSettings from './en/settings.json';

const LANG_KEY = 'eriko_lang';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      auth: enAuth,
      chat: enChat,
      settings: enSettings,
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

// Persist language changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANG_KEY, lng);
});

export default i18n;
